class LoadMoreProducts {
  constructor() {
    this.container = document.getElementById('product-grid');
    this.loadMoreBtn = document.getElementById('LoadMoreBtn');
    this.loadMoreContainer = document.getElementById('LoadMoreContainer');
    
    if (!this.container || !this.loadMoreBtn) return;
    
    this.currentPage = parseInt(this.container.dataset.currentPage) || 1;
    this.totalProducts = parseInt(this.container.dataset.totalProducts) || 0;
    this.productsPerLoad = parseInt(this.container.dataset.productsPerLoad) || 16;
    this.collectionUrl = this.container.dataset.collectionUrl || '';
    this.isLoadMoreEnabled = this.container.dataset.enableLoadMore === 'true';
    
    this.isLoading = false;
    this.loadedProducts = this.container.querySelectorAll('.grid__item').length;
    
    // Store bound method reference for cleanup
    this.boundLoadMore = this.loadMoreProducts.bind(this);
    
    console.log('LoadMore initialized:', {
      currentPage: this.currentPage,
      totalProducts: this.totalProducts,
      loadedProducts: this.loadedProducts,
      isEnabled: this.isLoadMoreEnabled
    });
    
    this.init();
  }
  
  init() {
    if (!this.isLoadMoreEnabled) return;
    
    // Remove any existing listeners first
    this.cleanup();
    
    this.loadMoreBtn.addEventListener('click', this.boundLoadMore);
    this.updateButtonState();
  }
  
  cleanup() {
    if (this.loadMoreBtn && this.boundLoadMore) {
      this.loadMoreBtn.removeEventListener('click', this.boundLoadMore);
    }
  }
  
  async loadMoreProducts() {
    if (this.isLoading || this.loadedProducts >= this.totalProducts) return;
    
    this.setLoadingState(true);
    
    try {
      const nextPage = this.currentPage + 1;
      const url = this.buildNextPageUrl(nextPage);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      
      if (newProducts.length > 0) {
        this.appendProducts(newProducts);
        this.currentPage = nextPage;
        this.loadedProducts += newProducts.length;
        this.updateButtonState();
      } else {
        this.hideLoadMoreButton();
      }
      
    } catch (error) {
      console.error('Error loading more products:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }
  
  buildNextPageUrl(page) {
    // Get current URL with all existing parameters (including filters)
    const currentUrl = new URL(window.location.href);
    const params = new URLSearchParams(currentUrl.search);
    
    // Update page parameter
    params.set('page', page);
    
    // Construct the new URL maintaining current filters
    return `${currentUrl.pathname}?${params.toString()}`;
  }
  
  appendProducts(newProducts) {
    const fragment = document.createDocumentFragment();
    
    newProducts.forEach((product, index) => {
      // Update animation order for scroll animations
      if (product.classList.contains('scroll-trigger')) {
        const newOrder = this.loadedProducts + index + 1;
        product.style.setProperty('--animation-order', newOrder);
      }
      
      fragment.appendChild(product.cloneNode(true));
    });
    
    this.container.appendChild(fragment);
    
    // Trigger scroll animations if enabled
    if (window.theme && window.theme.initializeScrollAnimationTrigger) {
      window.theme.initializeScrollAnimationTrigger();
    }
    
    // Reinitialize any Shopify features for new products
    this.reinitializeFeatures();
  }
  
  reinitializeFeatures() {
    // Reinitialize quick add functionality if present
    if (window.theme && window.theme.quickAdd) {
      window.theme.quickAdd.init();
    }
    
    // Reinitialize any other product card features
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  }
  
  setLoadingState(loading) {
    this.isLoading = loading;
    
    if (loading) {
      this.loadMoreBtn.classList.add('loading');
      this.loadMoreBtn.disabled = true;
      // Show spinner
      const spinner = this.loadMoreBtn.querySelector('.load-more-spinner');
      if (spinner) {
        spinner.style.display = 'inline-block';
      }
    } else {
      this.loadMoreBtn.classList.remove('loading');
      this.loadMoreBtn.disabled = false;
      // Hide spinner
      const spinner = this.loadMoreBtn.querySelector('.load-more-spinner');
      if (spinner) {
        spinner.style.display = 'none';
      }
    }
  }
  
  updateButtonState() {
    // More precise check for when to hide button
    const shouldHide = this.loadedProducts >= this.totalProducts;
    
    console.log('Button state check:', {
      loadedProducts: this.loadedProducts,
      totalProducts: this.totalProducts,
      shouldHide: shouldHide
    });
    
    if (shouldHide) {
      this.hideLoadMoreButton();
    } else {
      this.showLoadMoreButton();
    }
  }
  
  hideLoadMoreButton() {
    if (this.loadMoreContainer) {
      this.loadMoreContainer.style.display = 'none';
    }
  }
  
  showLoadMoreButton() {
    if (this.loadMoreContainer) {
      this.loadMoreContainer.style.display = 'block';
    }
  }
  
  showError() {
    const errorText = this.loadMoreBtn.querySelector('.load-more-text');
    if (!errorText) return;
    
    const originalText = errorText.textContent;
    
    errorText.textContent = 'Error loading products. Try again.';
    
    setTimeout(() => {
      errorText.textContent = originalText;
    }, 3000);
  }
}

// Global instance management
let loadMoreInstance = null;

function initializeLoadMore() {
  // Cleanup existing instance
  if (loadMoreInstance && typeof loadMoreInstance.cleanup === 'function') {
    loadMoreInstance.cleanup();
  }
  
  // Create new instance
  loadMoreInstance = new LoadMoreProducts();
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeLoadMore);

// Listen for various events that might indicate facet updates
// Shopify's facets system can trigger different events depending on the theme
const facetEvents = [
  'facet:updated', 
  'facets:updated',
  'shopify:section:load',
  'facet-filters-form:updated'
];

facetEvents.forEach(eventName => {
  document.addEventListener(eventName, () => {
    setTimeout(initializeLoadMore, 100);
  });
});

// Additional observer for DOM changes in case events don't fire
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // Check if product grid was replaced
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.id === 'product-grid' || node.querySelector('#product-grid')) {
            setTimeout(initializeLoadMore, 100);
          }
        }
      });
    }
  });
});

// Start observing when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.querySelector('.product-grid-container') || document.body;
  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
});